// extracted by mini-css-extract-plugin
export default {"card":"I1-z"};